import i18n from "i18next";

export const actionTypes = {
    SET_SUCCESS_LOGIN: "SET_SUCCESS_LOGIN",
    SET_SUCCESS_LOGOUT: "SET_SUCCESS_LOGOUT",
};

export const setSuccessLogin = (payload) => ({
    type: actionTypes.SET_SUCCESS_LOGIN,
    payload,
});

export const setSuccessLogout = () => {
    i18n.changeLanguage("en");
    return { type: actionTypes.SET_SUCCESS_LOGOUT };
};
